import { render, staticRenderFns } from "./Camadas.vue?vue&type=template&id=b28fe072&lang=pug"
import script from "./Camadas.vue?vue&type=script&lang=js"
export * from "./Camadas.vue?vue&type=script&lang=js"
import style0 from "./Camadas.vue?vue&type=style&index=0&id=b28fe072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports